<template>
  <div class="table-craft">
    <el-popover placement="right" width="400" trigger="hover">
      <el-table :data="info.orderCraftBeans" :row-class-name="$props.tableClassName"
                :header-row-class-name="$props.tableClassName">
        <el-table-column property="craft_name" label="工艺名称" align="center"></el-table-column>
        <el-table-column property="craft_count" width="90" label="工艺数量" align="center"></el-table-column>
      </el-table>
      <div class="mb10 mt10" :class="{[$props.tableClassName]:true}" v-if="!is_Empty(info.craft_remark)">
        工艺备注信息:{{$props.tableClassName}}
        <span v-html="info.craft_remark"></span>
      </div>
      <img-view :img="info.drawings"/>
      <el-button type="text" slot="reference"
                 @click="craft_show = true;">
        工艺信息
      </el-button>
    </el-popover>
    <!-- 选择工艺 -->
    <select-craft
        :show.sync="craft_show"
        :length="info.goods_length"
        :width="info.goods_width"
        :select_craft_list.sync="info.orderCraftBeans"
        :disabled="true"
        :craft_remark.sync="craft_remark"
    />
  </div>
</template>

<script>
export default {
  name: "table-column",
  props: {
    info: {
      type: Object,
      default: () => {
        return {
          orderCraftBeans: [],
          craft_remark: "",
          length: "",
          width: "",
        }
      }
    },
    tableClassName: {
      type: String,
      default: ""
    }
  },
  created() {
    if (!this.is_Empty(this.$props.info)) {
      this.craft_remark = this.$props.info.craft_remark;
    }
  },
  watch: {
    'info.craft_remark'(n) {
      this.craft_remark = n;
    }
  },
  data() {
    return {
      craft_remark: "",
      craft_show: false,
    }
  }
}
</script>

<style scoped>
.table-craft {

}
</style>


// WEBPACK FOOTER //
// src/components/table-column.vue